import { I18nProvider } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import messages from "./en";

export default polyglotI18nProvider(locale => messages, "en", { onMissingKey: (key: string) => `*${key}*` });
